import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  action?: React.ReactNode;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  title,
  action,
  noPadding = false
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden ${className}`} data-id="element-208">
      {(title || action) && <div className="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50/50" data-id="element-209">
          {title && <h3 className="font-semibold text-gray-900" data-id="element-210">{title}</h3>}
          {action && <div data-id="element-211">{action}</div>}
        </div>}
      <div className={noPadding ? '' : 'p-6'} data-id="element-212">{children}</div>
    </div>;
}